<template>
  <div>
    <input :type="inputType" :name="inputName" :class="updateClass" @input="updateInput" :maxlength="maxLength" v-model="inputContent"/>
  </div>
</template>

<script>
export default {
  props: ['inputName','inputType','maxLength','inputValue','inputClass'],
  data() {
    return {
      inputContent: this.inputValue,
      inputLength: this.maxLength,
      defaultClass: 'form-control'
    }
  },
  methods: {
    updateInput() {
      this.$emit('input',this.inputContent)
    },
  },
  computed: {
    updateClass() {
      if(this.inputClass !== '') {
        return this.defaultClass
      }
      return this.inputClass
    }
  }
}
</script>